/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalPersonResource
 */
export interface LegalPersonResource {
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResource
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResource
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResource
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResource
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResource
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResource
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResource
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalPersonResource
     */
    zipCode?: string;
}

/**
 * Check if a given object implements the LegalPersonResource interface.
 */
export function instanceOfLegalPersonResource(value: object): value is LegalPersonResource {
    return true;
}

export function LegalPersonResourceFromJSON(json: any): LegalPersonResource {
    return LegalPersonResourceFromJSONTyped(json, false);
}

export function LegalPersonResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalPersonResource {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'city': json['city'] == null ? undefined : json['city'],
        'street': json['street'] == null ? undefined : json['street'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
    };
}

export function LegalPersonResourceToJSON(value?: LegalPersonResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'countryCode': value['countryCode'],
        'country': value['country'],
        'city': value['city'],
        'street': value['street'],
        'zipCode': value['zipCode'],
    };
}

